import { render, staticRenderFns } from "./PropertiesData.vue?vue&type=template&id=33451a1c"
import script from "./PropertiesData.vue?vue&type=script&lang=js"
export * from "./PropertiesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports